import React from 'react'

const InfoCard = () => {
    return (
        <div style={{textAlign:'center', padding:'0 10%'}}>
            Try saying: <br/>
             Add income for ₹100 in category salary for next monday...
        </div>
    )
}

export default InfoCard
